function talsa_handleClick(event) {
  console.log("Click event detected", event.target);

  if (event.target.closest("#menu-toggle")) {
    event.preventDefault()
    toggleMobileMenu()
  }

  /* Acordeón categorías: click en ítem abre/cierra submenú (evita recarga en touch) */
  const menuLink = event.target.closest(".categories-menu .menu-item > .menu-link");
  if (menuLink) {
    const menuItem = menuLink.closest(".menu-item");
    if (menuItem && menuItem.classList.contains("has-submenu")) {
      event.preventDefault();
      event.stopPropagation();
      menuItem.classList.toggle("open");
      return;
    }
  }

  /* En móvil y tablet: evitar recarga al tocar links de level-1 que tienen level-2 */
  if (event.target.closest(".categories-menu") && window.matchMedia("(max-width: 1024px)").matches) {
    const level1Link = event.target.closest(".categories-menu .submenu.level-1 > li > a");
    if (level1Link) {
      const li = level1Link.closest("li");
      if (li && li.querySelector(".submenu.level-2")) {
        event.preventDefault();
        event.stopPropagation();
        li.classList.toggle("open");
        return;
      }
    }
  }

  if (event.target.closest("#header__search")) {
    event.preventDefault()
    toggleSearchBar()
  }

  if (event.target.closest(".header__cart__btn")) {
    event.preventDefault()
    document.dispatchEvent(new CustomEvent(Cart.OPEN))
  }

  if (event.target.closest(".side-cart-close")) {
    event.preventDefault()
    document.dispatchEvent(new CustomEvent(Cart.CLOSE))
  }

  if (event.target.closest(".add-to-cart-btn")) {
    event.preventDefault()
    const qty = (undefined != document.querySelector('product-qty input[name=quantity]')?.value) ? document.querySelector('product-qty input[name=quantity]')?.value : 1
    
    document.dispatchEvent(new CustomEvent(Cart.ADD, { detail: { productId: event.target.dataset.variantId, quantity: qty, btn: event.target } }))
  }

  if (event.target.closest("#cartquote")) {
    event.preventDefault()
    QuoteCart.open()
  }

  // Manejo de submenús mobile
  if (event.target.closest(".submenu-toggle")) {
    event.preventDefault()
    const toggle = event.target.closest(".submenu-toggle")
    const menuItem = toggle.closest(".menu-item-mobile")
    menuItem.classList.toggle("open")
  }

  // Cerrar submenús al hacer click fuera
  if (!event.target.closest(".menu-item-mobile") && !event.target.closest(".header__menu__mobile")) {
    document.querySelectorAll(".menu-item-mobile.open").forEach(item => {
      item.classList.remove("open")
    })
  }
}

function talsa_handleSearch() {
  document.querySelectorAll('[data-live-search]').forEach(component => {
        const searchField = component.querySelector('[data-live-search-input]')
        const results = component.querySelector("[data-live-search-results]")
        const clearBtn = component.querySelector('[data-search-live-clear]')
        const noResultsTemplate = component.querySelector("template[data-template='no-results']")
        const resultHeaderTemplate = component.querySelector("template[data-template='results']")
        const resultFooterTemplate = component.querySelector("template[data-template='see-all']")
        const resultProductTemplate = component.querySelector("template[data-template='product']")

        const handleInput = debounce(function (e) {
            const query = e.target.value.trim()

            clearBtn.style.display = (query.length == 0)? 'none' : 'block'

            if (query.length < 2) return
            
            // Normalizo (quito espacios y separadores comunes de SKUs)
            const norm = query.replace(/[\s\-_.]/g, '');

            // Heurística simple: si es alfanumérico y “largo” ⇒ tratamos como SKU
            // const looksLikeSku = /^[A-Za-z0-9]+$/.test(norm) && norm.length >= 4;
            const looksLikeSku = !isNaN(norm)

            // Si parece SKU: usamos el campo variants.sku
            // Para aproximación, probamos con wildcard al final (prefijo)
            const skuQuery = `variants.sku:${norm}*`; // “empieza por…”
            const normalQuery = query;                // búsqueda normal por texto

            const q = looksLikeSku ? skuQuery : normalQuery;

            // Búsqueda exacta: solo productos que tengan todas las palabras en el nombre, tipo o etiquetas.
            // Si no hay ninguno, se muestran los similares que sugiere Shopify.
            const exactQuery = looksLikeSku ? '' : buildExactQuery(query)
            const requestId = ++lastRequestId

            let search
            if (exactQuery) {
                search = getProducts(exactQuery).then(products => products.length
                    ? { products, mode: 'exact' }
                    : getProducts(q).then(products => ({ products, mode: 'similar' })))
            } else {
                search = getProducts(q).then(products => ({ products, mode: 'normal' }))
            }

            search
            .then(({ products, mode }) => {
                // Si el usuario siguió escribiendo, se ignora esta respuesta
                if (requestId !== lastRequestId) return

                results.innerHTML = ''
                if (0 === products.length) {
                    results.appendChild(noResultsTemplate.content.cloneNode(true))
                    results.innerHTML = results.innerHTML.replace('|terms|', query)
                } else {
                    results.appendChild(resultHeaderTemplate.content.cloneNode(true))
                    const productList = document.createElement('div')
                    productList.className = 'product-list'

                    products.map(product => {
                        const productClone = resultProductTemplate.content.cloneNode(true)
                        const a = productClone.querySelector('a')
                        const img = productClone.querySelector('img')
                        const span = productClone.querySelector('span')

                        if (null == product.image) {
                            product.image = "//talsa.com.co/cdn/shop/t/26/assets/no-image.svg?v=93587334215709882451772571088"
                        }

                        a.href = product.url
                        img.src = product.image
                        span.textContent = img.alt = product.title

                        productList.appendChild(productClone)
                    })

                    results.appendChild(productList)

                    results.appendChild(resultFooterTemplate.content.cloneNode(true))

                    results.innerHTML = results.innerHTML
                        .replace('|count|', products.length)
                        .replaceAll('|terms|', query)

                    if (mode === 'similar') {
                        const heading = results.querySelector('h3')
                        if (heading) heading.textContent = `No encontramos coincidencias exactas para "${query}". Quizás buscabas:`
                    }

                    // "Más info":
                    // - exactos: la página muestra solo las coincidencias exactas (conserva el orden por precio)
                    // - similares: se ordena por relevancia; por precio saldrían primero productos caros que no tienen relación
                    const seeAll = results.querySelector('.goto-search')
                    if (seeAll && (mode === 'exact' || mode === 'similar')) {
                        const url = new URL(seeAll.getAttribute('href'), window.location.origin)
                        if (mode === 'exact') url.searchParams.set('q', exactQuery)
                        else url.searchParams.delete('sort_by')
                        seeAll.setAttribute('href', url.pathname + url.search)
                    }
                }
            })
            .catch((err) => {
                //results.innerHTML = "<p>Error al buscar</p>";
                console.log('error',  err)
            })
        }, 400)

        const clearInput = () => {
            searchField.value = ''
            results.innerHTML = ''
            clearBtn.style.display = 'none'
        }

        searchField.addEventListener('input', handleInput)
        clearBtn.addEventListener('click', clearInput)
    })

    let lastRequestId = 0

    function getProducts(q) {
        return fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product`)
            .then(res => res.json())
            .then(data => data.resources.results.products)
    }

    // Palabras que no se exigen en la búsqueda exacta (y operadores de búsqueda de Shopify)
    const EXACT_SEARCH_IGNORED_WORDS = ['de', 'del', 'la', 'las', 'el', 'los', 'y', 'o', 'para', 'con', 'en', 'por', 'un', 'una', 'x', 'a', 'al', 'or', 'and', 'not']

    // "licuadora 10" => (title:licuadora* OR product_type:licuadora* OR tag:licuadora*) AND (title:10* OR ...)
    // Shopify ya ignora mayúsculas y tildes, y reconoce plurales
    function buildExactQuery(query) {
        return query
            .split(/[^\p{L}\p{N}]+/u)
            .filter(word => word && !EXACT_SEARCH_IGNORED_WORDS.includes(word.toLowerCase()))
            .map(word => `(title:${word}* OR product_type:${word}* OR tag:${word}*)`)
            .join(' AND ')
    }

    function debounce(fn, delay) {
        let timeout
        return function (...args) {
            clearTimeout(timeout)
            timeout = setTimeout(() => fn.apply(this, args), delay)
        }
    }

    const renderProduct = (product) => {
        const clone = component.querySelector("template[data-template='product']").content.cloneNode(true)

    }
}
function toggleMobileMenu() {
  const toggle = document.getElementById("menu-toggle");
  const mobileMenu = document.querySelector(".header__menu__mobile");

  const display = mobileMenu.style.display;

  mobileMenu.style.display =
    display === "" || display === "none" ? "block" : "none";
  toggle.querySelector(".icon--open").style.display =
    display === "" || display === "none" ? "none" : "inline";
  toggle.querySelector(".icon--close").style.display =
    display === "" || display === "none" ? "inline" : "none";
  toggle.querySelector("label").textContent =
    display === "" || display === "none" ? "CERRAR" : "MENÚ";
}
function toggleSearchBar() {
  const searchForm = document.querySelector(".mobile-search.desktop.main");

  searchForm.style.display =
    searchForm.style.display === "" || searchForm.style.display === "none"
      ? "block"
      : "none";
}

const Cart = {
  UPDATE: "cart:updated",
  ADD: "cart:added",
  REMOVE: "cart:removed",
  OPEN: "cart:open",
  CLOSE: "cart:close",
  UPDATE_SIDE_CART: "cart:update-side-cart",
  UPDATE_CART_ITEM: "cart:update-item",

  handleUpdate(event) {
    console.log("Cart updated", event.detail);
    fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const count = cart.item_count
          console.log('>>', cart.item_count)
          document.querySelectorAll('.header__cart__btn sup').forEach(el => {
            el.textContent = count
            el.classList.toggle('has-items', count > 0)
          })          
        })
  },
  handleAdd(event) {
    console.log("Item added to cart", event.detail);
    // Handle item added logic here
    event.detail.btn.disabled = true
    event.detail.btn.textContent = (window.mode == 'commercial')? "En tu carrito ✔" : "En tu cotización ✔"
    setTimeout(() => {
            event.detail.btn.disabled = false
            event.detail.btn.textContent = (window.mode == 'commercial')? "¡Al carrito!" : "Cotiza"
        }, 1500)

    fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({ id: event.detail.productId, quantity: event.detail.quantity })
        })
        .then(res => res.json())
        .then(data => {
            document.dispatchEvent(new CustomEvent(Cart.UPDATE))
        })
  },
  handleRemove(event) {
    console.log("Item removed from cart", event.detail);
    // Handle item removed logic here
  },
  handleOpen(event) {
    console.log("Cart opened", event.detail);
    // Handle cart open logic here  
    const overlay = document.querySelector(".side-cart")
    overlay.classList.add("open")
    overlay.classList.remove("hidden")

    document.dispatchEvent(new CustomEvent(Cart.UPDATE_SIDE_CART))
  },
  handleClose(event) {
    console.log("Cart closed", event.detail);
    // Handle cart close logic here
    const overlay = document.querySelector(".side-cart")
    overlay.classList.remove("open")
    setTimeout(() => overlay.classList.add("hidden"), 300)
  },
  handleUpdateSideCart(event) {
    console.log("Side cart updated", event.detail);
    // Handle side cart update logic here

    fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
            const cartBody = document.querySelector(".side-cart-body")
            const cartItem = document.querySelector('template[data-template="cart-item"]')

            cartBody.innerHTML = ''

            if (0 === cart.items.length) {
                cartBody.appendChild(document.querySelector('template[data-template="cart-no-items"]').content.cloneNode(true))
                if (window.mode == 'industrial') {
                  document.querySelector('.side-cart-empty p').innerHTML = 'Tu cotización esta vacía'
                }
                return;
            }

            let cartItems = document.createElement('ul')
            
            cart.items.forEach((item, index) => {
                const clone = cartItem.content.cloneNode(true)
                const li = clone.querySelector("li")

                li.dataset.li = index

                if (null == item.image) {
                    item.image = "//talsa.com.co/cdn/shop/t/26/assets/no-image.svg?v=93587334215709882451772571088"
                }

                clone.querySelector('img').src = item.image
                clone.querySelector('img').alt = item.title
                clone.querySelector('.cart-item-title').textContent = item.product_title
                if (window.mode == 'commercial') {
                  clone.querySelector('.cart-item-price').textContent = new Intl.NumberFormat('es-CO', { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 0, currencyDisplay: 'narrowSymbol' }).format(item.line_price / 100)
                }
                clone.querySelector('input').value = item.quantity
                
                const qtyInput = clone.querySelector('input')
                const btnLess = clone.querySelectorAll('.button.icon')[0]
                const btnMore = clone.querySelectorAll('.button.icon')[1]
                const removeBtn = clone.querySelector('.side-cart-actions .button')

                btnLess.addEventListener('click', (e) => {
                  const newQty = Math.max(1, parseInt(qtyInput.value, 10) - 1)
                  document.dispatchEvent(new CustomEvent(Cart.UPDATE_CART_ITEM, { detail: { key: item.key, quantity: newQty, button: btnLess } }))
                })

                btnMore.addEventListener('click', (e) => {
                  const newQty = Math.min(10, parseInt(qtyInput.value, 10) + 1)
                  document.dispatchEvent(new CustomEvent(Cart.UPDATE_CART_ITEM, { detail: { key: item.key, quantity: newQty, button: btnMore } }))
                })
                removeBtn.addEventListener('click', (e) => {
                  document.dispatchEvent(new CustomEvent(Cart.UPDATE_CART_ITEM, { detail: { key: item.key, quantity: 0, button: removeBtn } }))
                })

                cartItems.appendChild(clone)
            })
            cartBody.appendChild(cartItems)
            document.querySelector(".side-cart-subtotal").innerHTML = new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 0, currencyDisplay: 'narrowSymbol' }).format(cart.total_price / 100)
        })
  },
  handleUpdateCartItem(event) {
    event.detail.button.disabled = true
    event.detail.button.classList.add('loading')

    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
            body: JSON.stringify({ id: event.detail.key, quantity: event.detail.quantity })
        })
        .then((res) => res.json())
        .then(() => {
            document.dispatchEvent(new CustomEvent(Cart.UPDATE))
            document.dispatchEvent(new Event(Cart.OPEN))
        });
  },
  

  init() {
    document.addEventListener(this.UPDATE, this.handleUpdate)
    document.addEventListener(this.ADD, this.handleAdd)
    document.addEventListener(this.REMOVE, this.handleRemove)
    document.addEventListener(this.OPEN, this.handleOpen)
    document.addEventListener(this.CLOSE, this.handleClose)
    document.addEventListener(this.UPDATE_SIDE_CART, this.handleUpdateSideCart)
    document.addEventListener(this.UPDATE_CART_ITEM, this.handleUpdateCartItem)
  }
}

const QuoteCart = {
   
  init(){
    const modalClose = document.querySelector('quotecart .modal-header .close')

    modalClose.addEventListener('click', (e) => {
      e.preventDefault()
      QuoteCart.close()
    })

    document.querySelector('quotecart form').addEventListener('submit', function (e) {
        e.preventDefault()

        const EMAIL_URL     = "https:\/\/n8n.talsa.com.co\/webhook\/cc6bbfef-5a54-43fe-b9bd-47e6b99b7944";
        const EMAIL_TO      = "info@talsa.com.co";
        const EMAIL_SUBJECT = "Solicitud de cotización";

        const formData = new FormData(this)
        const data = Object.fromEntries(formData.entries())

        fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const count = cart.item_count
          

          const formData = new FormData(this)
          const data = Object.fromEntries(formData.entries())
          const bodyHtml = `
              <h2>Solicitud de información de productos industriales</h2>
              <p><strong>Cliente:</strong> ${data.name}</p>
              <p><strong>Documento:</strong> ${data.id_type.toUpperCase()} ${data.id_number}</p>
              <p><strong>Email:</strong> ${data.email}</p>
              <p><strong>Teléfono:</strong> ${data.phone}</p>
              <p><strong>País:</strong> ${data.country}</p>
              <p><strong>Ciudad:</strong> ${data.city}</p>
              <p><strong>Método de contacto:</strong> ${data.contact_method}</p>
              <p><strong>Mensaje:</strong><br>${data.message}</p>
              <h3>Productos</h3>
              `;
          const itemsHtml = cart.items.map(item => `
            <div style="margin-bottom:10px;">
              <p><strong>${item.title}</strong> (x${item.quantity})</p>
              <p>SKU: ${item.sku}</p>
            </div>
          `).join("");
          
          fetch(EMAIL_URL, {
              method: 'POST',
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                  "body": bodyHtml + itemsHtml,
                  "to": EMAIL_TO,
                  "subject": EMAIL_SUBJECT
              })
          })
          .then(response => response.json())
          .then(data => {
              if (data.success) {
                document.querySelector('quotecart .modal-success-message').style.display = 'block'
                document.querySelector('quotecart .modal-body').style.display = 'none'

                fetch('/cart/clear.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  }
                })
                .then(response => response.json())
                .then(data => {
                  document.dispatchEvent(new CustomEvent(Cart.UPDATE))
                })
                .catch(error => {
                  console.error('Error clearing cart:', error);
                });

              } else {
              alert('Error al enviar la solicitud. Inténtalo de nuevo más tarde.')
              }
          })
          .catch(error => {
              //console.error('Error:', error)
              alert('Error al enviar la solicitud. Inténtalo de nuevo más tarde.')
          })

          
        })

    })
  },
  open() {
    document.querySelector('quotecart').style.display = 'flex'
    document.dispatchEvent(new CustomEvent(Cart.CLOSE))
  },
  close() {
    document.querySelector('quotecart').style.display = 'none'
  }
  
}

// Función para inicializar el menú desplegable
function initDropdownMenu() {
  const menuItems = document.querySelectorAll(".header__menu .menu-item.has-submenu")
  
  menuItems.forEach(item => {
    const menuLink = item.querySelector(".menu-link")
    
    // Para desktop: hover
    if (window.innerWidth >= 769) {
      item.addEventListener("mouseenter", function() {
        item.classList.add("open")
      })
      
      item.addEventListener("mouseleave", function() {
        item.classList.remove("open")
      })
    } else {
      // Para mobile: click
      menuLink.addEventListener("click", function(e) {
        if (item.querySelector(".submenu")) {
          e.preventDefault()
          // Cerrar otros submenús abiertos
          menuItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove("open")
            }
          })
          item.classList.toggle("open")
        }
      })
    }
  })
  
  // Cerrar submenús al hacer click fuera (solo desktop)
  if (window.innerWidth >= 769) {
    document.addEventListener("click", function(e) {
      if (!e.target.closest(".header__menu .menu-item")) {
        menuItems.forEach(item => {
          item.classList.remove("open")
        })
      }
    })
  }
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("Document loaded and ready")

  document.addEventListener("click", talsa_handleClick, true)
  /* En touch: evitar recarga al tocar .menu-link (móvil) y links de level-1 con level-2 (móvil + tablet) */
  document.addEventListener("touchend", function (e) {
    const isMobile = window.matchMedia("(max-width: 768px)").matches
    const isTabletOrMobile = window.matchMedia("(max-width: 1024px)").matches
    if (isMobile) {
      const menuLink = e.target.closest(".categories-menu .menu-item > .menu-link")
      if (menuLink) {
        const menuItem = menuLink.closest(".menu-item")
        if (menuItem && menuItem.classList.contains("has-submenu")) {
          e.preventDefault()
          menuItem.classList.toggle("open")
          return
        }
      }
    }
    if (isTabletOrMobile) {
      const level1Link = e.target.closest(".categories-menu .submenu.level-1 > li > a")
      if (level1Link) {
        const li = level1Link.closest("li")
        if (li && li.querySelector(".submenu.level-2")) {
          e.preventDefault()
          li.classList.toggle("open")
        }
      }
    }
  }, { passive: false })
  talsa_handleSearch()
  initDropdownMenu()
  
  // Reinicializar el menú al cambiar el tamaño de la ventana
  let resizeTimer
  window.addEventListener("resize", function() {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function() {
      initDropdownMenu()
    }, 250)
  })
  
  Cart.init()
  QuoteCart.init()
  document.dispatchEvent(new CustomEvent(Cart.UPDATE))
});

// Navigation stack — pila de navegación interna para botón "Volver".
// Vive en sessionStorage (por pestaña). Si la página actual ya está en la pila,
// hacemos rewind en vez de duplicarla → evita loops cuando el usuario vuelve
// a una página visitada antes.
(function () {
  var KEY = '__talsa_nav_stack';

  function getStack() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function setStack(stack) {
    try { sessionStorage.setItem(KEY, JSON.stringify(stack)); } catch (e) {}
  }
  function currentPath() {
    return window.location.pathname + window.location.search;
  }

  function track() {
    var stack = getStack();
    var current = currentPath();
    var idx = stack.indexOf(current);
    if (idx !== -1) {
      stack.splice(idx + 1);
    } else {
      stack.push(current);
    }
    setStack(stack);
  }

  function goBack(fallback) {
    var stack = getStack();
    stack.pop();
    var target = stack[stack.length - 1];
    if (target) {
      stack.pop();
      setStack(stack);
      window.location.href = target;
    } else {
      setStack([]);
      window.location.href = fallback || '/';
    }
  }

  window.TalsaNav = { goBack: goBack, _track: track, _get: getStack };
  track();
})();
